<script setup>
import { useTypewriter } from '@/composables/typewriter'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
})

const displayed = useTypewriter(() => props.title)
</script>

<template>
  <q-item-label class="text-left ellipsis">{{ displayed }}</q-item-label>
</template>
